import { Routes, RouterModule } from '@angular/router';
import { FilesComponent } from './files.component';
import { ListFilesComponent } from './list-files/list-files.component';
import { EditFileComponent } from './edit-file/edit-file.component';
import { AuthguardService } from '../authguard.service';
import { ModuleWithProviders } from '@angular/core';

export const filesRoutes: Routes = [
    {
        path: 'files',
        component: FilesComponent,
        canActivate: [AuthguardService], // comment out for testing during development
        children: [
            {path: '',
                redirectTo: 'list',
                pathMatch: 'full'},
            {path: 'new',
                component: EditFileComponent},
            {path: 'list',
                component: ListFilesComponent},
            {path: 'edit/:id',
                component: EditFileComponent},
        ]
    }
];



// WEBPACK FOOTER //
// ./src/app/files/files.routes.ts